import script from "./QWasteSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./QWasteSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./QWasteSwitcher.vue?vue&type=style&index=0&id=d9c94d9c&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9c94d9c"]])

export default __exports__